import { IApplicationDetails } from 'features/ApplicationForm/types';
import ApplicantInformationDetails from './ApplicationInformationDetails';
import FinancialInformation from './FinancialInformation';
import ProjectOverview from './ProjectOverview';
import EconomicOverview from './EconomicOverview';

export const BFIPApplicationDetails = ({
  applicationData,
  files,
}: IApplicationDetails) => {
  return (
    <>
      <ApplicantInformationDetails step1={applicationData?.step1} />
      <FinancialInformation step2={applicationData?.step2} />
      <ProjectOverview step3={applicationData?.step3} />
      <EconomicOverview step4={applicationData?.step4} />
    </>
  );
};
